import { FormNavButtonContinue } from 'platform/forms-system/src/js/components/FormNavButtons';
import SchemaForm from 'platform/forms-system/src/js/components/SchemaForm';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import identityVerification from '../../config/chapters/veteranInformation/identityVerification';
import content from '../../locales/en/content.json';
import {
  selectHealthEnrollmentStatus,
  selectVesRecordFound,
} from '../../selectors';
import LoginRequiredAlert from '../FormAlerts/LoginRequiredAlert';
import ServerErrorAlert from '../FormAlerts/ServerErrorAlert';

const IdentityVerificationForm = ({ data, onChange, onLogin, onSubmit }) => {
  const {
    hasServerError,
    hasRateLimitError,
    loading: isSubmittingForm,
  } = useSelector(selectHealthEnrollmentStatus);
  const vesRecordFound = useSelector(selectVesRecordFound);

  const loginRequired = useMemo(
    () => vesRecordFound || hasRateLimitError,
    [hasRateLimitError, vesRecordFound],
  );

  const schemaFormFooter = useMemo(() => {
    if (hasServerError) return <ServerErrorAlert />;
    if (loginRequired) return <LoginRequiredAlert handleLogin={onLogin} />;
    return isSubmittingForm ? (
      <va-loading-indicator
        message={content['identity-verification--loading-message']}
        class="vads-u-margin-y--4"
        set-focus
      />
    ) : (
      <div className="vads-u-margin-y--4">
        <FormNavButtonContinue
          primaryButtonText={
            content['identity-verification--submit-button-text']
          }
          submitToContinue
          useWebComponents
          enableAnalytics
        />
      </div>
    );
  }, [hasServerError, isSubmittingForm, loginRequired, onLogin]);

  return (
    <div className="vads-u-margin-top--2p5">
      <SchemaForm
        name="Identity Form"
        title="Identity Form"
        schema={identityVerification.schema}
        uiSchema={identityVerification.uiSchema}
        onSubmit={onSubmit}
        onChange={onChange}
        data={data}
      >
        {schemaFormFooter}
      </SchemaForm>
    </div>
  );
};

IdentityVerificationForm.propTypes = {
  data: PropTypes.object,
  onChange: PropTypes.func,
  onLogin: PropTypes.func,
  onSubmit: PropTypes.func,
};

export default IdentityVerificationForm;
